var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "q-body-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-grey-10 no-underline",
                  attrs: {
                    to: {
                      name: "expenses-dashboard",
                      params: { teamId: _vm.activeTeam.id }
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$tc("expense", 2)) + "\n      "
                  )
                ]
              ),
              _vm._v("\n      / "),
              _c("span", { staticClass: "text-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("capture_expense")))
              ]),
              _vm.isCommitted
                ? _c(
                    "q-chip",
                    {
                      staticClass: "on-right status-chip",
                      attrs: { color: "positive", small: "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row items-center no-wrap" },
                        [
                          _c("q-icon", {
                            attrs: { name: "lock", size: "1rem" }
                          }),
                          _c("span", { staticClass: "on-right" }, [
                            _vm._v(_vm._s(_vm.$t("committed")))
                          ])
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.expenseLoaded
            ? _c(
                "div",
                [
                  !_vm.isCommitted
                    ? _c(
                        "q-btn",
                        {
                          staticClass: "text-grey-8 q-mr-md",
                          attrs: { flat: "", icon: "lock" },
                          on: { click: _vm.handleCommit }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("commit")) +
                                "\n        "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "q-btn",
                    {
                      staticClass: "q-mr-md",
                      attrs: {
                        color: "primary",
                        flat: "",
                        icon: "delete",
                        disable: _vm.isCommitted
                      },
                      on: { click: _vm.handleDelete }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("delete")) + "\n      "
                      )
                    ]
                  ),
                  _c(
                    "q-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSave }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("save")) + "\n      ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "layout-padding",
          staticStyle: { "min-height": "calc(100vh - 60px - 70px)" }
        },
        [
          _vm.expenseLoaded
            ? _c("div", { staticClass: "row full-height" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _vm.document
                      ? _c("document-viewer", {
                          attrs: {
                            document: _vm.document,
                            showDownloadButton: true
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("expense-form", {
                      model: {
                        value: _vm.formData,
                        callback: function($$v) {
                          _vm.formData = $$v
                        },
                        expression: "formData"
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }